class WebSocketClient {
  constructor() {
    this.sockets = {};
    this.handlers = {};
  }

  connect(name, url, token) {
    if (this.sockets[name]) return;

    console.log(`[${name}] Trying to connect with token:`, token);

    if (!token) {
      console.error(`[${name}] No token provided. Cannot connect.`);
      return;
    }

    const wsUrl = url.includes("?")
      ? `${url}&token=${token}`
      : `${url}?token=${token}`;
    console.log(`[${name}] Final wsUrl: ${wsUrl}`);

    const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      console.log(`[${name}] WebSocket connected`);
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log(`[${name}] Message received:`, data);

        if (this.handlers[name]) {
          this.handlers[name].forEach((handler) => handler(data));
        }
      } catch (err) {
        console.error(`[${name}] Error parsing message:`, err);
      }
    };

    ws.onclose = () => {
      console.log(`[${name}] WebSocket disconnected`);
      delete this.sockets[name];
    };

    ws.onerror = (err) => {
      console.error(`[${name}] WebSocket error:`, err);
    };

    this.sockets[name] = ws;
    this.handlers[name] = [];
  }

  send(name, message) {
    const ws = this.sockets[name];
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify(message));
    } else {
      console.warn(`[${name}] Cannot send message, socket not open`);
    }
  }

  subscribe(name, handler) {
    if (!this.handlers[name]) this.handlers[name] = [];
    this.handlers[name].push(handler);
  }

  unsubscribe(name, handler) {
    if (this.handlers[name]) {
      this.handlers[name] = this.handlers[name].filter((h) => h !== handler);
    }
  }

  disconnect(name) {
    if (this.sockets[name]) {
      this.sockets[name].close();
      delete this.sockets[name];
      delete this.handlers[name];
    }
  }

  disconnectAll() {
    Object.keys(this.sockets).forEach((name) => this.disconnect(name));
  }
}

const websocketClient = new WebSocketClient();
export default websocketClient;
